// @ts-nocheck
import React from 'react'
import { URL } from '../../service/Service';

const Price = ({ element_value, label, compact = false, photo, id }) => {

    const options = [];
    for (let i = 0; i <= 10; i++) {
        options.push(<option key={i} value={i}>{i}</option>);
    }


    return (
        <>
            <div className={`${compact ? 'm-0 p-3' : 'm-2 mr-5 p-4'} w-full overflow-hidden rounded border bg-white shadow`}>
                {photo && <img src={`${URL}/productImage/${id}`} alt={label || 'Produto'} className="mb-3 h-36 w-full rounded-xl object-cover" />}
                <div className={`flex justify-between ${compact ? 'flex-col items-stretch gap-3' : 'flex-col items-center md:flex-row md:items-start'}`}>
                    <div className={`${compact ? 'mb-0 px-3' : 'mb-5 p-2 lg:mr-5'} flex min-h-16 w-full min-w-0 items-center justify-between gap-3 rounded-md border bg-white shadow-sm`}>
                        <span className="min-w-0 flex-1 break-words text-sm font-medium uppercase text-gray-500">{label}</span>
                        <span className="shrink-0 text-lg font-bold text-gray-800">
                            {`${parseFloat(element_value).toFixed(2).replace(/\./g, ',')} €`}
                        </span>
                    </div>
                    <div className={`${compact ? 'mb-0 w-full px-3' : 'mb-5 w-full p-2 md:w-fit'} flex min-h-16 items-center justify-between gap-3 rounded-md border bg-white shadow-sm`}>
                        <span className="min-w-0 text-xs font-medium uppercase tracking-wide text-gray-500">Quantidade</span>
                        <input
                            type="number"
                            className={`${compact ? 'w-20 text-right' : 'w-20 md:w-24'} min-h-11 rounded-lg border border-slate-200 px-2 text-xl font-bold focus:border-emerald-500 focus:ring-emerald-100`}
                            placeholder="0"
                            min="0"
                            inputMode="numeric"
                            aria-label={`Quantidade de ${label || 'artigos'}`}
                            onWheel={() => document.activeElement.blur()}
                            step="1"
                        />
                    </div>
                </div>
            </div>
        </>

    )
}

export default Price
